import type { EntityOptions } from 'models';
import { Card, Col, Empty, type EmptyProperties, Icon, InfinityLoading, Row, Skeleton } from 'ui';
import { ChannelsSlider } from '../components';
import { CARDS_IN_ROW } from '../constants';
import { useChannelsInfiniteQuery } from '../queries';

type P = {
  emptyDescription: EmptyProperties['description'];
  getPathToEntityDetail: (id: string, options: EntityOptions) => string;
  navigateToChannelDetail: (id: string) => Promise<void>;
  organizationId?: string;
};

const CustomChannels = ({ emptyDescription, getPathToEntityDetail, navigateToChannelDetail, organizationId }: P) => {
  const {
    data: channelsData,
    fetchNextPage,
    hasNextPage,
    isFetching,
    isLoading,
  } = useChannelsInfiniteQuery({
    organizationId,
    pageSize: CARDS_IN_ROW,
  });

  const channels = channelsData?.pages.flat();

  return (
    <>
      {isLoading || !channels ? (
        <Skeleton active paragraph={{ rows: 12 }} />
      ) : // eslint-disable-next-line sonarjs/no-nested-conditional -- TODO: fix later
      channels.length === 0 ? (
        <Card>
          <Row justify="center">
            <Col>
              <Empty description={emptyDescription} image={<Icon color="secondary" icon="compass-line" />} maxWidth />
            </Col>
          </Row>
        </Card>
      ) : (
        <>
          {channels.map((channel) => (
            <ChannelsSlider
              channelId={channel.id}
              controls={{
                seeAll: {
                  async onClick() {
                    await navigateToChannelDetail(channel.id);
                  },
                },
                title: channel.name,
              }}
              description={channel.description}
              getPathToEntityDetail={getPathToEntityDetail}
              key={`channel-${channel.id}`}
            />
          ))}
          <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
        </>
      )}
    </>
  );
};

export default CustomChannels;
